import * as React from 'react';
import Translate from '../../functions/translate';
import { createMuiTheme, MuiThemeProvider, Button } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import { blue } from "@material-ui/core/colors";
import * as Modal from '../modal/modalDialog';

const alertDialog = (props) => {
  const theme = createMuiTheme({
    overrides: {
      MuiFormControl: {
        marginNormal: {
          marginTop: 5,
          marginBottom: 0,
          width: '100%'
        },
        root: {
          width: '100%',
        }
      },
      MuiFormControlLabel: {
        root: {
          marginLeft: '0px',
        }
      },
      MuiDialog: {
        paper: {
          margin: 0,
          maxWidth: '90% !important',
          maxheight: 300,
          minHeight: 190,
        },
        paperFullWidth: {
          width: '35%'
        }
      },
    },
    palette: {
      primary: blue
    }
  })

  return (
    <MuiThemeProvider theme={theme}>
      <Dialog
        open={props.isOpen}
        onClose={props.onClose}
        fullWidth
        disableBackdropClick={true}>
        <Modal.DialogTitle id="customized-dialog-title" onClose={props.onClose}>{props.headerTitle}</Modal.DialogTitle>
        <Modal.DialogContent>
          {props.children}
        </Modal.DialogContent>
        <Modal.DialogActions>
          <div>
            <Button onClick={props.onClose} variant="contained" style={{ marginRight: 10 }}>
              {Translate("OK")}
            </Button>
          </div>
        </Modal.DialogActions>
      </Dialog>
    </MuiThemeProvider>
  )
}

export default alertDialog;